import {
  IMAGES_UPLOAD_REQUEST,
  IMAGES_UPLOAD_SUCCESS,
  IMAGES_UPLOAD_FAIL,
  IMAGES_UPLOAD_RESET,
  IMAGE_REMOVE_REQUEST,
  IMAGE_REMOVE_SUCCESS,
  IMAGE_REMOVE_FAIL,
  PDF_UPLOAD_REQUEST,
  PDF_UPLOAD_SUCCESS,
  PDF_UPLOAD_FAIL,
  IMAGE_UPLOAD_SUCCESS,
  IMAGE_UPLOAD_REQUEST,
  IMAGE_UPLOAD_FAIL,
} from "./imageTypes";

export const imageReducer = (state = { imageResponse: [] }, action) => {
  switch (action.type) {
    // REQUEST
    case IMAGES_UPLOAD_REQUEST:
      return { ...state, loading: true };

    case IMAGE_REMOVE_REQUEST:
      return { ...state, loading: true };
    // FAILED
    case IMAGES_UPLOAD_FAIL:
      return { ...state, loading: false, error: action.payload };

    case IMAGES_UPLOAD_FAIL:
      return { ...state, loading: false, error: action.payload };

    // SINGLE IMAGE

    // REQUEST
    case IMAGE_UPLOAD_REQUEST:
      return { ...state, loading: true };

    // FAILED
    case IMAGE_UPLOAD_SUCCESS:
      return { ...state, loading: false, singleImage: action.payload };

    case IMAGE_UPLOAD_FAIL:
      return { ...state, loading: false, error: action.payload };

    // SUCCESS
    case IMAGES_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        imageResponse: action.payload,
        successResponse: true,
      };
    case IMAGE_REMOVE_SUCCESS:
      return {
        ...state,
        loading: false,
        // removed: true,
      };
    // RESET
    case IMAGES_UPLOAD_RESET:
      return {
        ...state,
        loading:false,
        imageResponse: [],
        successResponse: false,
        error: null
      };
    // PDF
    case PDF_UPLOAD_REQUEST:
      return { ...state, loading: true };
    case PDF_UPLOAD_SUCCESS:
      return { ...state, loading: false, pdfOut: action.payload };
    case PDF_UPLOAD_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
